import styles from './App.module.css';
import Navbar from './components/Navbar/Navbar'
import { useEffect, useState } from 'react';
import CrawlCostEstimator from './pages/CrawlCostEstimator/CrawlCostEstimator';
import Login from './pages/Login/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useAuth } from './Auth/AuthContext';
import { Spinner } from 'react-bootstrap';
import SpiderLibrary from './pages/SpiderLibrary/SpiderLibrary';
import Monitoring from './pages/Monitoring/Monitoring';
import Dashboard from './pages/Dashboard/Dashboard';
import SearchCrawlerMonitoring from './pages/SearchCrawlerKickoff/SearchCrawlerMonitoring/SearchCrawlerMonitoring';
import SearchMatchReview from './pages/SearchCrawlerKickoff/SearchMatchReview/SearchMatchReview';
import SpiderScheduling from './pages/SpiderScheduling/SpiderScheduling';
import SearchCrawlerPortalKickoff from './pages/SearchCrawlerKickoff/SearchCrawlerPortalKickoff/SearchCrawlerPortalKickoff';
import CrawlStatusPage from './pages/CrawlStatusPage/CrawlStatusPage';

function App() {
  const navigate = useNavigate();
  const [role, setRole] = useState("admin");
  const location = useLocation();


  // Authentication for user and logout
  const { user, logout, loading } = useAuth();
  let navBarOptions;
  let routes;
  if (user){
    navBarOptions = [
      {
        href: "/control-panel", text: "Control Panel",
        children: [
          {href: "/control-panel/platform-status-page", text: "Platform Status Page"},
          {href: "/control-panel/crawl-status-page", text: "Crawl Status Page"},
          {href: "/control-panel/crawl-cost-estimator", text: "Crawl Cost Estimator"}
        ]
      },
      {href: "/spider-library", text: "Spider Library",
        children: [
          {href: "/spider-library", text: "Spider Library"},
          {href: "/spider-scheduling", text: "Spider Scheduling"},
        ]
      },
      {href: "/search-crawler/portal-kickoff", text: "Search Crawler",
        children: [
          {href: "/search-crawler/portal-kickoff", text: "Portal Kickoff"},
          {href: "/search-crawler/monitoring", text: "Monitoring"},
          {href: "/search-crawler/match-review", text: "Match Review"},
        ]
      },
    ];
    routes = (
        <Routes>
          {user && <Route path="/control-panel" element={ <Dashboard/>}/>}
          {user && <Route path="/control-panel/platform-status-page" element={ <Monitoring/>}/>}
          {user && <Route path="/control-panel/crawl-status-page" element={ <CrawlStatusPage userEmail={user?.email}/>}/>}
          {user && <Route path="/control-panel/crawl-cost-estimator" element={<CrawlCostEstimator/>}/>}
          {user && <Route path="/spider-library" element={ <SpiderLibrary/>}/>}
          {user && <Route path="/spider-scheduling" element={ <SpiderScheduling/>}/>}
          {user && <Route path="/search-crawler/portal-kickoff" element={ <SearchCrawlerPortalKickoff userEmail={user?.email}/>}/>}
          {user && <Route path="/search-crawler/monitoring" element={ <SearchCrawlerMonitoring userEmail={user?.email}/>}/>}
          {user && <Route path="/search-crawler/match-review" element={ <SearchMatchReview userEmail={user?.email}/>}/>}
        </Routes>
    );
    
  } else {
    navBarOptions = [];
    routes = <Routes>
      <Route path="/login" element={<Login />}/>
    </Routes>
  }

  // Log out of the session and redirect to the login page
  const handleLogout = async () => {
    await logout();
    navigate("/login"); // Redirect after logout
  };

  // Handle redirects/refreshes
  useEffect(() => {
    if (!loading){
      if (user){
        if (role === "admin" && (location.pathname === "/login"  || location.pathname === "/")){
          navigate("/control-panel");
        }
      } else {
        navigate("/login");
      }
    }
  }, [user, role, navigate, loading, location]);

  return (

    <div className={styles.App}> 
        <Navbar navBarOptions={navBarOptions} handleLogout={handleLogout} user={user}/>
        <div className={styles.AppPage}>

          {routes}
          {loading && <div className={styles.spinnerContainer}>
            <Spinner/>
          </div>}
        </div>
    </div>
  );

}

export default App;
